import { Div, DivProps, Heading, P, Svg } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React from 'react';
import { Avatar, AvatarProps } from './Avatar';
import { AvatarMobile } from './AvatarMobile';

export interface CommentWithAvatarProps extends DivProps {
  avatar: AvatarProps;
  comment: React.ReactNode;
  commentTitle: React.ReactNode;
  showSuccess?: boolean;
  mobile?: boolean;
}

export const CommentWithAvatar: React.FC<CommentWithAvatarProps> = ({
  avatar,
  comment,
  commentTitle,
  showSuccess,
  children,
  mobile = true,
  ...divProps
}) => {
  return (
    <Div
      display={[mobile ? 'flex' : 'none', 'flex']}
      alignItems={['flex-end', 'stretch']}
      {...divProps}
    >
      <Avatar mr={[2, 4]} display={['none', 'none', 'block']} {...avatar} />
      <Div position="relative" ml={[0, 0, 4]}>
        <Svg
          display={['none', 'none', 'block']}
          filter="drop-shadow(0px -5px 3px rgba(0, 0, 0, 0.1))"
          height={29}
          left={-30}
          position="absolute"
          style={{
            transform: 'rotate(-90deg)',
          }}
          top={6}
          viewBox="0 0 27 17"
          width={39}
          zIndex={1}
        >
          <path
            d="M10.1846 1.9125L0 17.0008H27L16.8154 1.9125C15.2295 -0.436976 11.7705 -0.436981 10.1846 1.9125Z"
            fill="white"
          />
        </Svg>
        <Div flexGrow={2} variant="primaryCard">
          {showSuccess ? (
            <Heading
              display="flex"
              alignItems="center"
              mb={[1, 2]}
              mt={0}
              as="h2"
              variant="H2"
            >
              <IconV2
                name="check"
                width={30}
                height={30}
                borderRadius="25px"
                backgroundColor="supplementary.2"
                fill="main.0"
                mr={2}
              />
              {'Gelukt!'}
            </Heading>
          ) : null}
          <Heading mb={[1, 2]} mt={0} as="h4" variant="H4">
            {commentTitle}
          </Heading>
          <P variant="bodyRegularToCaption">{comment}</P>
          <Div display={['flex', 'flex', 'none']} justifyContent={'flex-end'}>
            <AvatarMobile {...avatar} />
          </Div>
          {children}
        </Div>
      </Div>
    </Div>
  );
};
